import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import ButtonDefault from '@/components/ui/ButtonDefault';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

interface FooterProps {
	loading?: boolean;
	edition?: boolean;
	onSubmit: () => void;
	onCancel: () => void;
}

export function Footer({ loading = false, edition = false, onSubmit, onCancel }: Readonly<FooterProps>) {
	const { xxl } = useBreakpoint();
	const gutter = xxl ? [30, 0] : [16, 0];
	const saveText = edition ? 'Save' : 'Create';

	return (
		<Row justify="center" gutter={gutter as [number, number]}>
			<Col>
				<ButtonDefault type="ghost" onClick={onCancel}>
					{I18n.get('Clear')}
				</ButtonDefault>
			</Col>
			<Col>
				<ButtonDefault type="primary" loading={loading} onClick={onSubmit}>
					{I18n.get(saveText)}
				</ButtonDefault>
			</Col>
		</Row>
	);
}
